module.exports = __webpack_public_path__ + "static/media/undraw_social_distancing_2g0u.0ffc67ee.svg";